<script>
  import { onMount } from 'svelte';
  let userName = "김철수";
  let promptList = [
    {
      id: 1,
      type: "진위판단형(OX문제)",
      name: "교과 기반 OX 문제 자동 생성",
      used: "Y",
      updated: "2025-06-17 10:45:02",
      prompt_content: `다음 문장을 보고 참이면 O, 거짓이면 X로 판단하세요.
  지문: "물은 90도에서 끓는다."
  정답: X

  지문은 교과 내용을 기반으로 하며, 1문장으로 구성하세요.`
    },
    {
      id: 2,
      type: "객관식형(오지선다)",
      name: "5지선다 객관식 문항 생성 (지문 포함)",
      used: "Y",
      updated: "2025-06-12 15:23:49",
      prompt_content: `다음 지문을 기반으로 5지선다 객관식 문제를 생성하세요.
  지문: "식물은 광합성을 통해 에너지를 만든다."

  문항:
  1. 식물은 동물과 동일한 방법으로 에너지를 만든다.
  2. 식물은 햇빛 없이 광합성이 가능하다.
  3. 식물은 광합성을 통해 에너지를 생성한다.
  4. 광합성은 식물이 자라기 위한 호흡이다.
  5. 식물은 산소를 소비해 에너지를 만든다.

  정답: 3`
    },
    {
      id: 3,
      type: "단답형(괄호넣기)",
      name: "빈칸 채우기 형식 문항 생성",
      used: "N",
      updated: "2025-06-03 08:19:27",
      prompt_content: `다음 문장을 괄호 형태의 빈칸으로 변경하고 정답을 제시하세요.
  문장: "대한민국의 수도는 서울이다."

  출력 예시:
  문항: "대한민국의 수도는 (        )이다."
  정답: "서울"`
    },
    {
      id: 4,
      type: "서술형",
      name: "심화 서술형 문제 자동 생성",
      used: "Y",
      updated: "2025-06-15 18:02:13",
      prompt_content: `다음 주제를 바탕으로 3문장 이상의 서술형 문제를 생성하세요.
  주제: "지구 온난화의 원인과 영향"

  출력 예시:
  "지구 온난화가 발생하게 된 주요 원인에 대해 설명하고, 그로 인한 사회적·환경적 영향을 기술하세요."`
    },
    {
      id: 5,
      type: "그림 선택형",
      name: "이미지 기반 정답 선택형 문항 생성",
      used: "Y",
      updated: "2025-06-11 11:11:11",
      prompt_content: `다음 이미지 설명을 바탕으로 올바른 그림을 선택하게 하세요.
  설명: "사과와 바나나 중 빨간색 과일을 고르세요."

  보기: [사과 이미지], [바나나 이미지]
  정답: 사과`
    },
    {
      id: 6,
      type: "사례 분석형",
      name: "사례 제시 후 분석/해석 문제 생성",
      used: "N",
      updated: "2025-05-30 14:40:00",
      prompt_content: `다음 사례를 바탕으로 분석 및 해석형 문항을 작성하세요.
  사례: "A 학생은 학교에서 친구와의 다툼 이후 혼자 있는 시간이 많아졌다."

  문항: "이 사례에서 A 학생의 심리 상태와 필요한 지원 방안에 대해 분석하시오."`
    },
    {
      id: 7,
      type: "코딩 문제형",
      name: "Python 코딩 문제 자동 생성 (테스트케이스 포함)",
      used: "Y",
      updated: "2025-06-10 09:25:14",
      prompt_content: `다음 요구사항을 기반으로 파이썬 함수 문제를 생성하세요.

  요구사항:
  - 정수 배열이 주어졌을 때, 짝수만 필터링하여 오름차순으로 정렬한 결과를 반환하는 함수를 작성하세요.

  예시 입력: [5, 2, 8, 1, 3]
  예시 출력: [2, 8]

  정답 함수명: filter_and_sort_even(numbers: List[int]) -> List[int]`
    }
  ];

  let selectedPrompt = promptList[0];
  let isEditing = false;

  const selectPrompt = (item) => {
    selectedPrompt = item;
  };

  const toggleEdit = () => {
    isEditing = !isEditing;
  };
</script>

<div class="examType-wrap d-flex flex-column h-100">
<p class="font-20 font-weight-700">문제유형 관리</p>
<section class="d-flex gap-10 h-100 mt-10">
    <!-- 문제유형 목록 -->
    <article class="examType-list flex-1 h-100">
    <div class="d-flex align-center">
        <p class="font-16 font-weight-700">문제유형 목록</p>
        <button class="btn bg-blue ml-auto">문제유형 등록</button>
    </div>
    <div class="d-flex flex-column h-100 mt-2 bg-white box-border">
        <div class="table-wrap">
        <table class="table-basic table-basic-examType">
            <thead>
            <tr>
                <th>번호</th>
                <th>문제유형</th>
                <th>프롬프트 이름</th>
                <th>사용여부</th>
                <th>수정일시</th>
            </tr>
            </thead>
            <tbody>
            {#each promptList as item}
                <tr on:click={() => selectPrompt(item)} class:selected={selectedPrompt.id === item.id}>
                <td>{item.id}</td>
                <td>{item.type}</td>
                <td>{item.name}</td>
                <td>{item.used}</td>
                <td>{item.updated}</td>
                </tr>
            {/each}
            </tbody>
        </table>
        </div>
    </div>
    </article>

    <!-- 프롬프트 정보 -->
    <article class="prompt-info flex-1 h-100">
    <div class="d-flex align-center">
        <p class="font-16 font-weight-700">프롬프트 정보</p>
        <div class="btn-group ml-auto">
        <button class="btn border-blue btn-edit" on:click={toggleEdit}>
            {isEditing ? '수정 중...' : '프롬프트 수정'}
        </button>
        {#if isEditing}
            <button class="btn bg-blue btn-cancel">저장</button>
        {/if}
        </div>
    </div>
    <div class="table-wrap mt-2" style="height:calc(100% - 4rem)">
        <table class="table-basic table-basic-promptInfo">
        <tbody>
            <tr>
            <th>문제유형</th>
            <td colspan="3">{selectedPrompt.type}</td>
            </tr>
            <tr>
            <th>프롬프트명</th>
            <td colspan="3">{selectedPrompt.name}</td>
            </tr>
            <tr>
            <th>프롬프트 내용</th>
            <td colspan="3" class="h-100 custom-textarea">
                <div class="prompt-cont">
                {selectedPrompt.prompt_content}
                </div>
            </td>
            </tr>
            <tr>
            <th>사용여부</th>
            <td colspan="3">{selectedPrompt.used}</td>
            </tr>
            <tr>
            <th>수정일시</th>
            <td>{selectedPrompt.updated}</td>
            <th>수정자</th>
            <td>홍길동</td>
            </tr>
        </tbody>
        </table>
    </div>
    </article>
</section>
</div>